<style scoped lang="sass">
#chat
  display: flex
  flex-direction: column
  padding: 0.7rem
  height: 100%
  box-sizing: border-box
  background-color: white
  .comments-wrapper
    flex-grow: 1
    overflow: scroll
    .comments
      display: flex
      flex-direction: column
      .comment
        flex-grow: 1
        display: flex
        flex-direction: row
        border-bottom: 1px solid var(--medium-gray)
        padding: 0.5rem 0
        .image
          padding: 0 0.5rem 0 0
          img
            width: 2rem
            height: 2rem
            border-radius: 1rem
        .content
          flex-grow: 1
          .name
            font-size: 1rem
            font-weight: 500
            display: flex
            justify-content: space-between
            .destroy-link
              font-size: 0.6rem
              &.confirm
                color: red
          .message
            font-size: 1rem
            font-weight: 300
          .created-at
            font-size: 0.7rem
            font-weight: 500
            color: var(--medium-gray)
  .new-comment
    position: relative
    .input-group
      margin-bottom: 0
      .input-control
        padding-right: 3rem
    .post-link
      position: absolute
      color: white
      right: 0.5rem
      top: 0
      height: 100%
      display: flex
      align-items: center
      color: var(--border-gray)
      font-size: 0.8rem
</style>
<template>
  <right-side-tray @close="$emit('close')">
    <div id="chat">
      <div class="comments-wrapper" @scroll="scrolled($event)">
        <div class="comments">
          <div v-for="(comment,i) in comments" class="comment" :key="i">
            <div class="image">
              <img :src="comment.user.avatar_url" />
            </div>
            <div class="content">
              <div class="name">
                <span>{{comment.user.short_informal_name}}</span>
                <span v-if="commentDestroyable(comment)">
                  <a href="#" @click.prevent="confirmDestroyComment(comment)" v-if="!commentConfirmingDestroy(comment)" class="destroy-link">Delete?</a>
                  <a href="#" @click.prevent="destroyComment(comment)" v-if="commentConfirmingDestroy(comment)" class="destroy-link confirm">DELETE</a>
                </span>
              </div>
              <div class="message">{{comment.message}}</div>
              <div class="created-at">{{niceTime(comment.created_at)}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="new-comment">
        <div class="input-group">
          <input type="text" v-model="newComment" @keypress.enter.prevent="createComment" class="input-control" placeholder="Add a comment...">
          <a href="#" class="post-link" @click.prevent="createComment">POST</a>
        </div>
      </div>
    </div>
  </right-side-tray>
</template>
<script>
import Vuex          from 'vuex';
import moment        from 'moment';

import RightSideTray from './right-side-tray.vue';

export default {
  name: 'Chat',
  props: {
    pool: {
      type: Object,
      required: true,
    }
  },
  components: {
    RightSideTray
  },
  data: function() {
    return {
      newComment:                '',
      loadingMore:               false,
      confirmingDestroyComments: []
    };
  },
  created: function() {
    this.$store.dispatch('comments/clear');
    this.$store.dispatch('comments/getMore', this.pool.id);
  },
  computed: {
    ...Vuex.mapGetters('comments', ['comments'])
  },
  methods: {
    ...Vuex.mapActions('comments', ['create', 'getMore', 'destroy']),
    createComment() {
      if (this.newComment.length) {
        this.create({pool_id: this.pool.id, message: this.newComment});
        this.newComment = '';
      }
    },
    niceTime(time) {
      const momentTime = moment(time);
      return `${momentTime.format('MMM D')} at ${momentTime.format('h:mmA')}`.toUpperCase();
    },
    scrolled(event) {
      if (event.target.scrollTop === event.target.scrollHeight - event.target.offsetHeight) {
        this.loadingMore = true;
        this.getMore(this.pool.id)
          .then(() => (this.loadingMore = false));
      }
    },
    commentDestroyable(comment) {
      return this.$root.currentUser.id === comment.user.id;
    },
    commentConfirmingDestroy(comment) {
      return !!this.confirmingDestroyComments.find(c => c.id === comment.id);
    },
    confirmDestroyComment(comment) {
      this.confirmingDestroyComments.push(comment);
    },
    destroyComment(comment) {
      this.destroy({comment, poolId: this.pool.id});
    }
  }
}
</script>
